<h2 mat-dialog-title>Upload Prices</h2>
<mat-card-subtitle
    >{{ data.productManufacturer?.product.name }} &#183;
    {{ data.productManufacturer?.manufacturer.name }}</mat-card-subtitle
>

<div mat-dialog-content>
    <mat-stepper
        [linear]="true"
        [selectedIndex]="stepIndex"
        (selectionChange)="
            stepIndex = $event.selectedIndex; onTabChanged($event)
        "
        #stepper
    >
        <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
        </ng-template>

        <mat-step>
            <ng-template matStepLabel>Upload Prices</ng-template>

            <form [formGroup]="priceImportForm">
                <div class="mb-3">
                    <mat-form-field class="w-100">
                        <mat-label>Price Effective From</mat-label>
                        <input
                            matInput
                            [matDatepicker]="picker"
                            [min]="minimumEffectiveFrom"
                            [disabled]="submitted"
                            formControlName="effective_from"
                            placeholder="Choose a date"
                        />

                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <mat-hint
                        >Set the date these price changes will take effect
                        from</mat-hint
                    >
                </div>

                <div class="mb-3">
                    <mat-label>Price File</mat-label>
                    <app-upload
                        controlName="price_file"
                        requiredFileType=".csv, .xls, .xlsx, .ods"
                        [disabled]="submitted"
                    ></app-upload>

                    <mat-hint
                        >Up to 500 MB &#183; Any valid Excel type
                        formats</mat-hint
                    >
                </div>
            </form>
        </mat-step>

        <mat-step label="Confirm Prices">
            <table [dataSource]="projectedPriceChanges" mat-table>
                <ng-container matColumnDef="tier">
                    <th mat-header-cell *matHeaderCellDef>Tier</th>
                    <td mat-cell *matCellDef="let price">{{ price.tier }}</td>
                </ng-container>

                <ng-container matColumnDef="operative_cost">
                    <th mat-header-cell *matHeaderCellDef>Operative Cost</th>
                    <td mat-cell *matCellDef="let price">
                        {{ price.operative_cost | currency }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="subcontractor_cost">
                    <th mat-header-cell *matHeaderCellDef>
                        Subcontractor Cost
                    </th>
                    <td mat-cell *matCellDef="let price">
                        {{ price.subcontractor_cost | currency }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="material_cost">
                    <th mat-header-cell *matHeaderCellDef>Material Cost</th>
                    <td mat-cell *matCellDef="let price">
                        {{ price.material_cost | currency }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="sell_price">
                    <th mat-header-cell *matHeaderCellDef>Sell Price</th>
                    <td mat-cell *matCellDef="let price">
                        {{ price.sell_price | currency }}
                    </td>
                </ng-container>

                <tr
                    mat-header-row
                    *matHeaderRowDef="[
                        'tier',
                        'operative_cost',
                        'subcontractor_cost',
                        'material_cost',
                        'sell_price'
                    ]"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="
                        let row;
                        columns: [
                            'tier',
                            'operative_cost',
                            'subcontractor_cost',
                            'material_cost',
                            'sell_price'
                        ]
                    "
                    [ngClass]="row.action"
                ></tr>
                <tr class="mat-row" *matNoDataRow>
                    <td
                        class="mat-cell"
                        style="text-align: center;"
                        colspan="999"
                    >
                        No Price updates were found...
                    </td>
                </tr>
            </table>

            <mat-paginator
                [pageSize]="pageSize"
                aria-label="Select page"
                showFirstLastButtons
            >
            </mat-paginator>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel>Save Prices</ng-template>
            {{ successfulRowCount }} Prices Saved. @if (failedRowCount) {
            <mat-accordion>
                <mat-expansion-panel hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon>warning</mat-icon>
                            {{ failedRowCount }} Unsaved Prices
                        </mat-panel-title>
                        <mat-panel-description>
                            Some prices could not be saved. Review them below.
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <table [dataSource]="failedPriceChanges" mat-table>
                        <ng-container matColumnDef="tier">
                            <th mat-header-cell *matHeaderCellDef>Tier</th>
                            <td mat-cell *matCellDef="let price">
                                {{ price.tier }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="operative_cost">
                            <th mat-header-cell *matHeaderCellDef>
                                Operative Cost
                            </th>
                            <td mat-cell *matCellDef="let price">
                                {{ price.operative_cost | currency }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="subcontractor_cost">
                            <th mat-header-cell *matHeaderCellDef>
                                Subcontractor Cost
                            </th>
                            <td mat-cell *matCellDef="let price">
                                {{ price.subcontractor_cost | currency }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="material_cost">
                            <th mat-header-cell *matHeaderCellDef>
                                Material Cost
                            </th>
                            <td mat-cell *matCellDef="let price">
                                {{ price.material_cost | currency }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="sell_price">
                            <th mat-header-cell *matHeaderCellDef>
                                Sell Price
                            </th>
                            <td mat-cell *matCellDef="let price">
                                {{ price.sell_price | currency }}
                            </td>
                        </ng-container>
                        <tr
                            mat-header-row
                            *matHeaderRowDef="[
                                'tier',
                                'operative_cost',
                                'subcontractor_cost',
                                'material_cost',
                                'sell_price'
                            ]"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="
                                let row;
                                columns: [
                                    'tier',
                                    'operative_cost',
                                    'subcontractor_cost',
                                    'material_cost',
                                    'sell_price'
                                ]
                            "
                        ></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td
                                class="mat-cell"
                                style="text-align: center;"
                                colspan="999"
                            >
                                No Price updates were found...
                            </td>
                        </tr>
                    </table>
                </mat-expansion-panel>
            </mat-accordion>
            }
        </mat-step>
    </mat-stepper>
</div>

<div mat-dialog-actions class="d-flex justify-content-between">
    @if (stepIndex !== 2) {
    <div>
        <button mat-button mat-dialog-close>Cancel</button>
    </div>
    } @if (stepIndex === 1) {
    <div>
        <div class="legend-container">
            <span class="legend-swatch new"></span>
            <span class="legend-label ps-1 align-self-center">New Price</span>
        </div>
        <div class="legend-container">
            <span class="legend-swatch edit"></span>
            <span class="legend-label ps-1 align-self-center"
                >Updated Price</span
            >
        </div>
        <div class="legend-container">
            <span class="legend-swatch delete"></span>
            <span class="legend-label ps-1 align-self-center"
                >Delete Price</span
            >
        </div>
    </div>
    }

    <div>
        @if (stepIndex !== 0 && stepIndex !== 2) {
        <button mat-stroked-button (click)="stepIndex = stepIndex - 1">
            Back
        </button>
        } @if (stepIndex === 0 && !submitted) {
        <button
            type="button"
            mat-stroked-button
            color="primary"
            (click)="uploadFile()"
        >
            @if (loading) {
            <mat-icon>
                <mat-spinner diameter="20"></mat-spinner>
            </mat-icon>
            } @if (!loading) {
            <span>Next</span>
            }
        </button>
        } @if (stepIndex === 0 && submitted) {
        <button
            type="button"
            mat-stroked-button
            color="primary"
            (click)="stepIndex = stepIndex + 1"
        >
            Next
        </button>
        } @if (stepIndex === 1) {
        <button mat-stroked-button color="primary" (click)="processPrices()">
            Next
        </button>
        } @if (stepIndex === 2) {
        <button mat-stroked-button mat-dialog-close color="primary">
            Complete
        </button>
        }
    </div>
</div>
